var _g, _path, _path2, _circle, _g2, _g3, _g4, _g5, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDandunLogoAdmin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 206,
    height: 62,
    viewBox: "0 0 206 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_di_216_25)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.5715 17.1431H19.8693C18.0816 17.1431 16.5879 18.5045 16.4226 20.2846C16.2342 22.314 17.8312 24.0661 19.8693 24.0661H26.5C29.2615 24.0661 31.5 26.3047 31.5 29.0661V29.9453C31.5 32.7067 29.2615 34.9453 26.5 34.9453H18.7344C17.1245 34.9453 15.6751 35.9208 15.0692 37.4123C14.0124 40.0137 15.9265 42.8574 18.7344 42.8574H33.5715C36.3329 42.8574 38.5715 40.6188 38.5715 37.8574V22.1431C38.5715 19.3816 36.3329 17.1431 33.5715 17.1431Z",
    fill: "#2C9547"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.2858 9.68692L22.5 9.64307L22.5001 42.8574L19.2858 42.8573V9.68692Z",
    fill: "url(#paint0_linear_216_25)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.31121 0.00260235V42.3055H16.6224H20.1387V10.1808C36.4415 8.90851 47.9493 13.3614 47.9493 30.8551C47.9493 44.85 36.0152 48.5608 30.0482 48.6668H8.31121V45.8042L0 52.8017L8.31121 61.0714V58.2088L31.6465 58.845C40.0856 58.845 48.1624 53.7559 51.1459 51.2114C63.4209 40.2699 60.3095 23.3275 57.2195 16.224C51.5934 2.99243 36.9742 -0.10342 30.3679 0.00260235H8.31121Z",
    fill: "#F6D724"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25.7143,
    cy: 30.0001,
    r: 1.07143,
    fill: "#F6D724"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_216_25)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M83.7749 17.476C86.5615 17.476 89.0062 18.0207 91.1089 19.11C93.2369 20.1993 94.8709 21.7573 96.0109 23.784C97.1762 25.7853 97.7589 28.116 97.7589 30.776C97.7589 33.436 97.1762 35.7667 96.0109 37.768C94.8709 39.744 93.2369 41.2767 91.1089 42.366C89.0062 43.4553 86.5615 44 83.7749 44H74.5029V17.476H83.7749ZM83.5849 39.478C86.3715 39.478 88.5249 38.718 90.0449 37.198C91.5649 35.678 92.3249 33.5373 92.3249 30.776C92.3249 28.0147 91.5649 25.8613 90.0449 24.316C88.5249 22.7453 86.3715 21.96 83.5849 21.96H79.8229V39.478H83.5849Z",
    fill: "#F6D724"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.1089 19.11L90.8789 19.554L90.881 19.5551L91.1089 19.11ZM96.0109 23.784L95.575 24.0292L95.5788 24.0356L96.0109 23.784ZM96.0109 37.768L95.5788 37.5164L95.5778 37.5181L96.0109 37.768ZM91.1089 42.366L90.881 41.9209L90.8789 41.922L91.1089 42.366ZM74.5029 44H74.0029V44.5H74.5029V44ZM74.5029 17.476V16.976H74.0029V17.476H74.5029ZM90.0449 37.198L89.6913 36.8444L90.0449 37.198ZM90.0449 24.316L89.6855 24.6637L89.6884 24.6666L90.0449 24.316ZM79.8229 21.96V21.46H79.3229V21.96H79.8229ZM79.8229 39.478H79.3229V39.978H79.8229V39.478ZM83.7749 17.976C86.4956 17.976 88.8588 18.5074 90.8789 19.554L91.3389 18.666C89.1536 17.5339 86.6275 16.976 83.7749 16.976V17.976ZM90.881 19.5551C92.9242 20.601 94.4847 22.0906 95.5751 24.0291L96.4466 23.5389C95.2571 21.4241 93.5495 19.7977 91.3367 18.6649L90.881 19.5551ZM95.5788 24.0356C96.6934 25.9498 97.2589 28.1911 97.2589 30.776H98.2589C98.2589 28.0409 97.659 25.6209 96.4429 23.5324L95.5788 24.0356ZM97.2589 30.776C97.2589 33.3609 96.6934 35.6022 95.5788 37.5164L96.4429 38.0196C97.659 35.9311 98.2589 33.5111 98.2589 30.776H97.2589ZM95.5778 37.5181C94.4883 39.4065 92.9275 40.8733 90.881 41.9209L91.3367 42.8111C93.5462 41.68 95.2534 40.0815 96.444 38.0179L95.5778 37.5181ZM90.8789 41.922C88.8588 42.9686 86.4956 43.5 83.7749 43.5V44.5C86.6275 44.5 89.1536 43.9421 91.3389 42.81L90.8789 41.922ZM83.7749 43.5H74.5029V44.5H83.7749V43.5ZM75.0029 44V17.476H74.0029V44H75.0029ZM74.5029 17.976H83.7749V16.976H74.5029V17.976ZM83.5849 39.978C86.4631 39.978 88.7592 39.1908 90.3984 37.5516L89.6913 36.8444C88.2906 38.2452 86.2799 38.978 83.5849 38.978V39.978ZM90.3984 37.5516C92.0368 35.9131 92.8249 33.6304 92.8249 30.776H91.8249C91.8249 33.4442 91.0929 35.4429 89.6913 36.8444L90.3984 37.5516ZM92.8249 30.776C92.8249 27.9211 92.0367 25.628 90.4013 23.9654L89.6884 24.6666C91.093 26.0947 91.8249 28.1082 91.8249 30.776H92.8249ZM90.4042 23.9683C88.7658 22.2753 86.4677 21.46 83.5849 21.46V22.46C86.2754 22.46 88.284 23.2154 89.6856 24.6637L90.4042 23.9683ZM83.5849 21.46H79.8229V22.46H83.5849V21.46ZM79.3229 21.96V39.478H80.3229V21.96H79.3229ZM79.8229 39.978H83.5849V38.978H79.8229V39.978Z",
    fill: "#F6D724"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_216_25)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M150.775 17.476C153.562 17.476 156.006 18.0207 158.109 19.11C160.237 20.1993 161.871 21.7573 163.011 23.784C164.176 25.7853 164.759 28.116 164.759 30.776C164.759 33.436 164.176 35.7667 163.011 37.768C161.871 39.744 160.237 41.2767 158.109 42.366C156.006 43.4553 153.562 44 150.775 44H141.503V17.476H150.775ZM150.585 39.478C153.372 39.478 155.525 38.718 157.045 37.198C158.565 35.678 159.325 33.5373 159.325 30.776C159.325 28.0147 158.565 25.8613 157.045 24.316C155.525 22.7453 153.372 21.96 150.585 21.96H146.823V39.478H150.585Z",
    fill: "#F6D724"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.109 19.11L157.879 19.554L157.881 19.5551L158.109 19.11ZM163.011 23.784L162.575 24.0292L162.579 24.0356L163.011 23.784ZM163.011 37.768L162.579 37.5164L162.578 37.5181L163.011 37.768ZM158.109 42.366L157.881 41.9209L157.879 41.922L158.109 42.366ZM141.503 44H141.003V44.5H141.503V44ZM141.503 17.476V16.976H141.003V17.476H141.503ZM157.045 37.198L156.691 36.8444L157.045 37.198ZM157.045 24.316L156.686 24.6637L156.688 24.6666L157.045 24.316ZM146.823 21.96V21.46H146.323V21.96H146.823ZM146.823 39.478H146.323V39.978H146.823V39.478ZM150.775 17.976C153.496 17.976 155.859 18.5074 157.879 19.554L158.339 18.666C156.154 17.5339 153.627 16.976 150.775 16.976V17.976ZM157.881 19.5551C159.924 20.601 161.485 22.0906 162.575 24.0291L163.447 23.5389C162.257 21.4241 160.55 19.7977 158.337 18.6649L157.881 19.5551ZM162.579 24.0356C163.693 25.9498 164.259 28.1911 164.259 30.776H165.259C165.259 28.0409 164.659 25.6209 163.443 23.5324L162.579 24.0356ZM164.259 30.776C164.259 33.3609 163.693 35.6022 162.579 37.5164L163.443 38.0196C164.659 35.9311 165.259 33.5111 165.259 30.776H164.259ZM162.578 37.5181C161.488 39.4065 159.928 40.8733 157.881 41.9209L158.337 42.8111C160.546 41.68 162.253 40.0815 163.444 38.0179L162.578 37.5181ZM157.879 41.922C155.859 42.9686 153.496 43.5 150.775 43.5V44.5C153.627 44.5 156.154 43.9421 158.339 42.81L157.879 41.922ZM150.775 43.5H141.503V44.5H150.775V43.5ZM142.003 44V17.476H141.003V44H142.003ZM141.503 17.976H150.775V16.976H141.503V17.976ZM150.585 39.978C153.463 39.978 155.759 39.1908 157.398 37.5516L156.691 36.8444C155.291 38.2452 153.28 38.978 150.585 38.978V39.978ZM157.398 37.5516C159.037 35.9131 159.825 33.6304 159.825 30.776H158.825C158.825 33.4442 158.093 35.4429 156.691 36.8444L157.398 37.5516ZM159.825 30.776C159.825 27.9211 159.037 25.628 157.401 23.9654L156.688 24.6666C158.093 26.0947 158.825 28.1082 158.825 30.776H159.825ZM157.404 23.9683C155.766 22.2753 153.468 21.46 150.585 21.46V22.46C153.275 22.46 155.284 23.2154 156.686 24.6637L157.404 23.9683ZM150.585 21.46H146.823V22.46H150.585V21.46ZM146.323 21.96V39.478H147.323V21.96H146.323ZM146.823 39.978H150.585V38.978H146.823V39.978Z",
    fill: "#F6D724"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_216_25)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M110.154 40.808H103.482L102.378 44H98.8499L104.874 27.224H108.786L114.81 44H111.258L110.154 40.808ZM109.242 38.12L106.818 31.112L104.394 38.12H109.242ZM132.11 44H128.75L121.142 32.504V44H117.782V27.224H121.142L128.75 38.744V27.224H132.11V44Z",
    fill: "#F6D724"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.154 40.808L110.626 40.6446L110.51 40.308H110.154V40.808ZM103.482 40.808V40.308H103.126L103.009 40.6446L103.482 40.808ZM102.378 44V44.5H102.734L102.85 44.1634L102.378 44ZM98.8499 44L98.3794 43.831L98.1391 44.5H98.8499V44ZM104.874 27.224V26.724H104.522L104.403 27.055L104.874 27.224ZM108.786 27.224L109.257 27.055L109.138 26.724H108.786V27.224ZM114.81 44V44.5H115.521L115.281 43.831L114.81 44ZM111.258 44L110.785 44.1634L110.902 44.5H111.258V44ZM109.242 38.12V38.62H109.944L109.714 37.9566L109.242 38.12ZM106.818 31.112L107.29 30.9486L106.818 29.5824L106.345 30.9486L106.818 31.112ZM104.394 38.12L103.921 37.9566L103.692 38.62H104.394V38.12ZM110.154 40.308H103.482V41.308H110.154V40.308ZM103.009 40.6446L101.905 43.8366L102.85 44.1634L103.954 40.9714L103.009 40.6446ZM102.378 43.5H98.8499V44.5H102.378V43.5ZM99.3205 44.169L105.345 27.393L104.403 27.055L98.3794 43.831L99.3205 44.169ZM104.874 27.724H108.786V26.724H104.874V27.724ZM108.315 27.393L114.339 44.169L115.281 43.831L109.257 27.055L108.315 27.393ZM114.81 43.5H111.258V44.5H114.81V43.5ZM111.73 43.8366L110.626 40.6446L109.681 40.9714L110.785 44.1634L111.73 43.8366ZM109.714 37.9566L107.29 30.9486L106.345 31.2754L108.769 38.2834L109.714 37.9566ZM106.345 30.9486L103.921 37.9566L104.866 38.2834L107.29 31.2754L106.345 30.9486ZM104.394 38.62H109.242V37.62H104.394V38.62ZM132.11 44V44.5H132.61V44H132.11ZM128.75 44L128.333 44.2759L128.481 44.5H128.75V44ZM121.142 32.504L121.559 32.2281L120.642 30.8425V32.504H121.142ZM121.142 44V44.5H121.642V44H121.142ZM117.782 44H117.282V44.5H117.782V44ZM117.782 27.224V26.724H117.282V27.224H117.782ZM121.142 27.224L121.559 26.9485L121.411 26.724H121.142V27.224ZM128.75 38.744L128.332 39.0195L129.25 40.4084V38.744H128.75ZM128.75 27.224V26.724H128.25V27.224H128.75ZM132.11 27.224H132.61V26.724H132.11V27.224ZM132.11 43.5H128.75V44.5H132.11V43.5ZM129.167 43.7241L121.559 32.2281L120.725 32.7799L128.333 44.2759L129.167 43.7241ZM120.642 32.504V44H121.642V32.504H120.642ZM121.142 43.5H117.782V44.5H121.142V43.5ZM118.282 44V27.224H117.282V44H118.282ZM117.782 27.724H121.142V26.724H117.782V27.724ZM120.724 27.4995L128.332 39.0195L129.167 38.4685L121.559 26.9485L120.724 27.4995ZM129.25 38.744V27.224H128.25V38.744H129.25ZM128.75 27.724H132.11V26.724H128.75V27.724ZM131.61 27.224V44H132.61V27.224H131.61Z",
    fill: "#F6D724"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_d_216_25)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M171.917 27.248V37.616C171.917 38.752 172.213 39.624 172.805 40.232C173.397 40.824 174.229 41.12 175.301 41.12C176.389 41.12 177.229 40.824 177.821 40.232C178.413 39.624 178.709 38.752 178.709 37.616V27.248H182.093V37.592C182.093 39.016 181.781 40.224 181.157 41.216C180.549 42.192 179.725 42.928 178.685 43.424C177.661 43.92 176.517 44.168 175.253 44.168C174.005 44.168 172.869 43.92 171.845 43.424C170.837 42.928 170.037 42.192 169.445 41.216C168.853 40.224 168.557 39.016 168.557 37.592V27.248H171.917ZM200.387 44H197.027L189.419 32.504V44H186.059V27.224H189.419L197.027 38.744V27.224H200.387V44Z",
    fill: "#F6D724"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.917 27.248H172.417V26.748H171.917V27.248ZM172.805 40.232L172.446 40.5808L172.451 40.5856L172.805 40.232ZM177.821 40.232L178.174 40.5856L178.179 40.5808L177.821 40.232ZM178.709 27.248V26.748H178.209V27.248H178.709ZM182.093 27.248H182.593V26.748H182.093V27.248ZM181.157 41.216L180.733 40.9498L180.732 40.9516L181.157 41.216ZM178.685 43.424L178.469 42.9727L178.467 42.974L178.685 43.424ZM171.845 43.424L171.624 43.8726L171.627 43.874L171.845 43.424ZM169.445 41.216L169.015 41.4722L169.017 41.4753L169.445 41.216ZM168.557 27.248V26.748H168.057V27.248H168.557ZM171.417 27.248V37.616H172.417V27.248H171.417ZM171.417 37.616C171.417 38.837 171.736 39.8514 172.446 40.5808L173.163 39.8832C172.689 39.3966 172.417 38.667 172.417 37.616H171.417ZM172.451 40.5856C173.161 41.2957 174.135 41.62 175.301 41.62V40.62C174.322 40.62 173.632 40.3523 173.158 39.8784L172.451 40.5856ZM175.301 41.62C176.48 41.62 177.463 41.297 178.174 40.5856L177.467 39.8784C176.995 40.351 176.297 40.62 175.301 40.62V41.62ZM178.179 40.5808C178.889 39.8514 179.209 38.837 179.209 37.616H178.209C178.209 38.667 177.936 39.3966 177.462 39.8832L178.179 40.5808ZM179.209 37.616V27.248H178.209V37.616H179.209ZM178.709 27.748H182.093V26.748H178.709V27.748ZM181.593 27.248V37.592H182.593V27.248H181.593ZM181.593 37.592C181.593 38.9422 181.297 40.0532 180.733 40.9498L181.58 41.4822C182.264 40.3948 182.593 39.0898 182.593 37.592H181.593ZM180.732 40.9516C180.175 41.8465 179.423 42.5177 178.469 42.9727L178.9 43.8753C180.026 43.3383 180.922 42.5375 181.581 41.4804L180.732 40.9516ZM178.467 42.974C177.518 43.4336 176.45 43.668 175.253 43.668V44.668C176.584 44.668 177.803 44.4064 178.903 43.874L178.467 42.974ZM175.253 43.668C174.073 43.668 173.012 43.434 172.063 42.974L171.627 43.874C172.725 44.406 173.937 44.668 175.253 44.668V43.668ZM172.065 42.9754C171.144 42.5222 170.415 41.8526 169.872 40.9567L169.017 41.4753C169.658 42.5314 170.529 43.3338 171.624 43.8726L172.065 42.9754ZM169.874 40.9598C169.338 40.0614 169.057 38.9467 169.057 37.592H168.057C168.057 39.0853 168.367 40.3866 169.015 41.4722L169.874 40.9598ZM169.057 37.592V27.248H168.057V37.592H169.057ZM168.557 27.748H171.917V26.748H168.557V27.748ZM200.387 44V44.5H200.887V44H200.387ZM197.027 44L196.61 44.2759L196.758 44.5H197.027V44ZM189.419 32.504L189.836 32.2281L188.919 30.8425V32.504H189.419ZM189.419 44V44.5H189.919V44H189.419ZM186.059 44H185.559V44.5H186.059V44ZM186.059 27.224V26.724H185.559V27.224H186.059ZM189.419 27.224L189.836 26.9485L189.688 26.724H189.419V27.224ZM197.027 38.744L196.61 39.0195L197.527 40.4084V38.744H197.027ZM197.027 27.224V26.724H196.527V27.224H197.027ZM200.387 27.224H200.887V26.724H200.387V27.224ZM200.387 43.5H197.027V44.5H200.387V43.5ZM197.444 43.7241L189.836 32.2281L189.002 32.7799L196.61 44.2759L197.444 43.7241ZM188.919 32.504V44H189.919V32.504H188.919ZM189.419 43.5H186.059V44.5H189.419V43.5ZM186.559 44V27.224H185.559V44H186.559ZM186.059 27.724H189.419V26.724H186.059V27.724ZM189.002 27.4995L196.61 39.0195L197.444 38.4685L189.836 26.9485L189.002 27.4995ZM197.527 38.744V27.224H196.527V38.744H197.527ZM197.027 27.724H200.387V26.724H197.027V27.724ZM199.887 27.224V44H200.887V27.224H199.887Z",
    fill: "#F6D724"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M140 22.4961H148V38.4961H140V22.4961Z",
    fill: "#1E1F1F"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_di_216_25",
    x: 11.7743,
    y: 16.1431,
    width: 29.7971,
    height: 31.7144,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.31 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_216_25"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_216_25",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_216_25"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_216_25",
    x: 70.5028,
    y: 17.4761,
    width: 31.2561,
    height: 34.5239,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_216_25"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_216_25",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_216_25",
    x: 137.503,
    y: 17.4761,
    width: 31.2561,
    height: 34.5239,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_216_25"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_216_25",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_216_25",
    x: 94.85,
    y: 27.2241,
    width: 41.2596,
    height: 24.7759,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_216_25"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_216_25",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d_216_25",
    x: 164.557,
    y: 27.2241,
    width: 39.8303,
    height: 24.9438,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_216_25"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_216_25",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_216_25",
    x1: 17.4491,
    y1: 35.834,
    x2: 22.5,
    y2: 35.834,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#212322"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#212322",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDandunLogoAdmin);
export default __webpack_public_path__ + "static/media/Dandun_logo_admin.22739d868f9be286564432a0c727a397.svg";
export { ForwardRef as ReactComponent };